import axios from './axios'
import { Consensi, Patient, VacciniTable } from '@/../../EshJSLib/models/patient'


export async function updateConsenso(params: Consensi,idConsenso:number) {
    const json = JSON.stringify(params);
    let  response ={} as any;

    response =  await axios.post(`/api/consensoUpdate`, json).catch((error) => {
        throw error
        })
    
    return response.data;
}